import { CONFIG_BUILD_ENV } from '@src/config/env'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import amplifyStageConfig from './aws-exports-staging.json'
import amplifyQAConfig from './aws-exports-qa.json'
import amplifyProdConfig from './aws-exports-prod.json'
import getBaseAmplifyConfig from './base-amplify-config'

function getEnvAmplifyConfig() {
  switch (CONFIG_BUILD_ENV) {
    case 'dev':
    case 'staging':
      return amplifyStageConfig
    case 'qa':
      return amplifyQAConfig
    case 'production':
      return amplifyProdConfig
    default:
      return amplifyProdConfig
  }
}

export default function getAmplifyConfig() {
  if (!isBrowser()) return
  return {
    ...getEnvAmplifyConfig(),
    ...getBaseAmplifyConfig(),
  }
}
